<template>
  <GeojsonLayer :layer="layerStyle" :sourceId="sourceId" :source="source" />
</template>

<script>
import GeojsonLayer from '@/components/map/mapbox-layers/GeojsonLayer.vue'

export default {
  name: 'MapSky',
  components: {
    GeojsonLayer
  },
  data() {
    return {
      sourceId: 'source-map-sky',
      layerId: 'layer-map-sky',
      source: {
        type: 'raster-dem'
      }
    }
  },
  computed: {
    layerStyle() {
      return {
        id: this.layerId,
        source: this.sourceId,
        type: 'sky',
        paint: {
          // set up the sky layer to use a color gradient
          'sky-type': 'gradient',
          // the sky will be lightest in the center and get darker moving radially outward
          // this simulates the look of the sun just below the horizon
          'sky-gradient': [
            'interpolate',
            ['linear'],
            ['sky-radial-progress'],
            0.8,
            'rgb(124,168,192)',
            1,
            'rgba(255,255,255,0.1)'
          ],
          'sky-gradient-center': [0, 0],
          'sky-gradient-radius': 90
        }
      }
    }
  }
}
</script>
